import React, { useCallback, useEffect, useImperativeHandle, useState } from 'react';
import classes from './rating.module.css';

// eslint-disable-next-line react/display-name
const Rating = React.forwardRef((props, ref) => {
  // rating 0 - 100

  const { rating, disabled, height } = props;

  // const starWidth = width ? width : 18;
  const starHeight = height || 20;
  const starWidth = height ? (height / 20) * 18 : 18;

  const [innerWidth, setInnerWidth] = useState(`${rating}%`);

  const divided = rating / 20;

  const result = divided - Math.floor(divided) > 0 ? Math.floor(divided) + 0.5 : divided;

  // 1 - 5
  const [value, setValue] = useState(result);

  useImperativeHandle(ref, () => ({
    value,
    setValue,
  }));

  useEffect(() => {
    setInnerWidth(`${value * 20}%`);
  }, [value]);

  const rootClass = disabled ? classes.rootDisabled : classes.root;

  return (
    <div
      className={rootClass}
      style={{
        width: `${starWidth * 5}px`,
        height: `${starHeight}px`,
        backgroundSize: `${starWidth}px ${starHeight}px`,
      }}
      onClick={event => {
        if (disabled) {
          return;
        }

        const { offsetX } = event.nativeEvent;
        let percent = Math.ceil((offsetX / (starWidth * 5)) * 5) * 20;

        percent = percent > 100 ? 100 : percent;
        setInnerWidth(`${percent}%`);
        setValue(Math.floor(percent / 20));
      }}
    >
      <div
        className={classes.ratingStar}
        style={{
          width: innerWidth,
          height: `${starHeight}px`,
          backgroundSize: `${starWidth}px ${starHeight}px`,
        }}
      />
      {rating}
    </div>
  );
});

export default Rating;
